import Favicon from './favicon.js'
export default Favicon



// WEBPACK FOOTER //
// ./src/plugins/favicon/index.js